module.exports = __webpack_public_path__ + "static/media/IMG_2621.337bad08.jpg";